
$.fn.loadAjax = function(options){
  var defaults = {
    obj: $(this),
    ajaxUrl: "",
    affectedObj: "",
    type: "replace or append",
    loadingDomList: '[{"template":"tournament_medium", "loop":"2"},{"template":"tournament_low", "loop":"3"}]'
  }
  var settings = $.extend(defaults, options);

  let currentPage = settings.obj.data("loadajax-page");

  // hide append button (loadmore) if total data less than limit (only if replace)

  // todo
  
  settings.obj.on("click", function(){
    // console.log(currentPage);

    // reconfig if load another page

    let ajaxUrl = settings.ajaxUrl.replace(":page:", currentPage);
    if (currentPage != "1") {
      currentPage += 1;
    }

    // reconfig if load another cate (only if tag append & has attr :cate: in url)

    switch (settings.type) {
      case 'replace':  
        currentPage = 1;
        break;
      case 'append': 
        if (ajaxUrl.indexOf(":cate:") > 0) {
          let currentCate = settings.obj.parent().parent().prev().
                            find(".active").children("a").data("loadajax-url").split("=")[1];
          ajaxUrl = ajaxUrl.replace(":cate:", currentCate);
        }
        break;
    }
  
    $.ajax({
      url: ajaxUrl,
      // dataType: 'htmjsonl',
      dataType: 'json',
      beforeSend: function(){
        // Add fake loaded content
        switch (settings.type) {
          case 'replace': 
            $(settings.affectedObj).empty();
          case 'append':
          default:
            // console.log(settings.loadingDomList);
            // var loadingDomList = JSON.parse(settings.loadingDomList);
            var loadingDomList = settings.loadingDomList;
            var loadingDom = ``;
            
            for (var i = 0, len = loadingDomList.length; i<len; i++) {
              // console.log(i);
              for (var j = 0, lenj = loadingDomList[i]["loop"]; j<lenj; j++) {
                loadingDom += loadingTemplate[loadingDomList[i].template];
              }
            }
            $(settings.affectedObj).append(loadingDom); 
          }
      },
      error: function(jqXHR, textStatus, errorThrown){
        alert('An error occurred... Look at the console (F12 or Ctrl+Shift+I, Console tab) for more information!');
        $('#result').html('<p>status code: '+jqXHR.status+'</p><p>errorThrown: ' + errorThrown + '</p><p>jqXHR.responseText:</p><div>'+jqXHR.responseText + '</div>');
        console.log('jqXHR:');
        console.log(jqXHR);
        console.log('textStatus:');
        console.log(textStatus);
        console.log('errorThrown:');
        console.log(errorThrown);
      },
      success: function(result, textStatus, jqXHR) {

        // console.log(result);

        let resultNoSpace = function(result){
          return result.replace(/(\s)+/g,"");
        }

        // console.log(resultNoSpace(result).length);

        if (resultNoSpace(result).length == 0) {
          // console.log(settings.type == 'replace');
          if (settings.type == 'replace') {
            // console.log(loadingTemplate.noresult);
            $(settings.affectedObj).find(".loadAjaxWait").remove();
            $(settings.affectedObj).append(loadingTemplate.noresult);
            
          } else if (settings.type == 'append') {
            $(settings.affectedObj).find(".loadAjaxWait").remove();
            $(settings.affectedObj).append(loadingTemplate.noresult);
            settings.obj.css({
              display: "none"
            });
          }
        } else {
          $(settings.affectedObj).find(".loadAjaxWait").remove();
          $(settings.affectedObj).append(result);
          $("[data-loadajax]").css({
            display: "inline-block"  
          });
        }

        // Send ajax and return real content
        settings.obj.parent().addClass("active"); 
        settings.obj.parent().siblings().removeClass("active");
      }
    });

  })
}

let loadingTemplate = {
  noresult: `
  <div class="error__single loadAjaxWait col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <span class="meta loading--block">
      <span class="container">
        <span class="meta__text">Không có kết quả</span>
      </span>
    </span>
  </div>`,
  loading: `
  <div class="error__single loadAjaxWait col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <span class="meta loading--block">
      <span class="container">
        <span class="meta__text">Đang load...</span>
      </span>
    </span>
  </div>`,
  tournament_medium: `
  <div class="tournament__single tournament__single--medium tournament__single--loading loadAjaxWait col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
    <a href="javascript:;">
      <span class="thumbnail">
        <span class="loading--img"></span>
      </span>
      <span class="meta">
        <span class="container">
          <span class="meta__title"><span class="loading--title"></span></span>
          <span class="meta__time"><span class="loading--text"></span></span>
        </span>
      </span>
    </a>
  </div>`,
  tournament_low: `
  <div class="tournament__single tournament__single--low tournament__single--loading loadAjaxWait col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
    <a href="javascript:;">
      <span class="thumbnail">
        <span class="loading--img"></span>
      </span>
      <span class="meta">
        <span class="container">
          <span class="meta__title"><span class="loading--title"></span></span>
          <span class="meta__time"><span class="loading--text"></span></span>
        </span>
      </span>
    </a>
  </div>`,
  news: `
  <div class="new__single new__single--loading loadAjaxWait col-xl-12 col-lg-12 col-md-12 col-sm-6 col-xs-12">
    <span class="thumbnail">
      <a href="javascript:;">
        <span class="loading--img"></span>
      </a>
    </span>
    <span class="meta">
      <span class="meta__tag"><span class="loading--text"></span></span>
      <span class="meta__time"><span class="loading--text"></span></span>
      <a href="javascript:;"><span class="meta__title"><span class="loading--title"></span></span></a>
      <span class="meta__thumbnail">
        <a href="javascript:;">
          <span class="loading--img"></span>
        </a>
      </span>
      <span class="meta__description">
        <span class="loading--paragraph"></span><br>
        <span class="loading--paragraph"></span><br>
        <span class="loading--paragraph"></span>
      </span>
    </span>
  </div>`,
  highlight: `
  <div class="video__single video__single--normal video__single--loading loadAjaxWait col-xl-12 col-lg-12 col-md-12 col-sm-6 col-xs-12">
    <a href="javascript:;">
      <span class="thumbnail">
        <span class="loading--img"></span>
      </span>
      <span class="meta">
        <span class="container">
          <span class="meta__title"><span class="loading--title"></span></span>
          <span class="meta__play">
            <span class="icon" data-icon="play"></span>
          </span>
        </span>
      </span>
    </a>
  </div>`,
  interview: `
  <div class="video__single video__single--interview video__single--loading loadAjaxWait col-xl-12 col-lg-12 col-md-12 col-sm-6 col-xs-12">
    <a href="#">
      <span class="thumbnail">
        <span class="loading--img"></span>
      </span>
      <span class="meta">
        <span class="container">
          <span class="meta__title"><span class="loading--title"></span></span>
        </span>
      </span>
    </a>
  </div>`,
  stream: `<div class="stream__single stream__single--low stream__single--loading loadAjaxWait col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
  <a href="#">
    <span class="thumbnail">
      <span class="loading--img"></span>
    </span>
    <span class="meta">
      <span class="meta__tags">
      <span class="loading--title"></span>
      </span>
      <span class="meta__participates"><span class="loading--title"></span></span>
      <span class="meta__tournament"><span class="loading--title"></span></span>
    </span>
  </a>
</div>
  `
}
